var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16297",
    "data-name": "Group 16297",
    transform: "translate(-1536 -143.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3422",
    "data-name": "Rectangle 3422",
    width: 30,
    height: 30,
    transform: "translate(1536 143.507)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16298",
    "data-name": "Group 16298",
    transform: "translate(1539 106.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11433",
    "data-name": "Path 11433",
    d: "M23.746,44.82c-1.306-1.571-7.117-2.745-11.44-2.745S2.172,43.249.866,44.82C-.1,45.978,0,48.572.005,48.682a.4.4,0,0,0,.349.378,26.584,26.584,0,0,0,2.813.165,26.584,26.584,0,0,0,2.813-.165.4.4,0,0,0,.35-.394V46.856h1.5v.791l-5.858,10.7h0a.39.39,0,0,0-.02.042l0,.009c0,.011-.008.023-.011.034l0,.012c0,.011,0,.023-.006.034s0,.008,0,.012a.4.4,0,0,0,0,.046v2.9h-.11a.4.4,0,1,0,0,.794H22.8a.4.4,0,1,0,0-.794h-.11v-2.9a.4.4,0,0,0,0-.046l0-.012c0-.012,0-.023-.006-.034l0-.012q0-.018-.011-.034l0-.009a.4.4,0,0,0-.02-.042h0l-5.858-10.7v-.791h1.5v1.809a.4.4,0,0,0,.35.394,26.582,26.582,0,0,0,2.813.165,26.582,26.582,0,0,0,2.813-.165.4.4,0,0,0,.349-.378C24.612,48.572,24.709,45.978,23.746,44.82ZM21.62,58.145H7.681a.4.4,0,0,0,0,.794H21.892v2.5H2.72v-2.5H6.161a.4.4,0,0,0,0-.794H2.993L8.578,47.939a.4.4,0,0,0,.049-.191V45.624h.8v2.125a.4.4,0,0,0,.4.4h4.963a.4.4,0,0,0,.4-.4V45.624h.8v2.125a.4.4,0,0,0,.049.191Zm-11.4-11.289h4.169v.5H10.222Zm11.223,1.575c-.95,0-1.882-.076-2.369-.123V46.459a.4.4,0,0,0-.4-.4h-1.9V45.5a.674.674,0,0,0-.673-.673H15.064a.674.674,0,0,0-.673.673v.56H10.222V45.5a.674.674,0,0,0-.673-.673H8.506a.674.674,0,0,0-.673.673v.56h-1.9a.4.4,0,0,0-.4.4v1.849c-.488.047-1.419.123-2.369.123S1.28,48.354.794,48.308a5.614,5.614,0,0,1,.683-2.98c.482-.58,2.045-1.214,4.18-1.7a32.067,32.067,0,0,1,6.65-.763,32.071,32.071,0,0,1,6.65.763c2.135.482,3.7,1.116,4.18,1.7a5.626,5.626,0,0,1,.683,2.98C23.332,48.355,22.4,48.431,21.445,48.431Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11434",
    "data-name": "Path 11434",
    d: "M156.009,170.463a4.275,4.275,0,1,0,4.275,4.275A4.28,4.28,0,0,0,156.009,170.463Zm0,7.756a3.481,3.481,0,1,1,3.481-3.481A3.485,3.485,0,0,1,156.009,178.219Z",
    transform: "translate(-143.703 -121.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11435",
    "data-name": "Path 11435",
    d: "M224.93,206.848a.423.423,0,1,0,.423.423A.424.424,0,0,0,224.93,206.848Z",
    transform: "translate(-212.624 -156.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11436",
    "data-name": "Path 11436",
    d: "M193.63,225.1a.423.423,0,1,0,.2.257A.424.424,0,0,0,193.63,225.1Z",
    transform: "translate(-182.78 -173.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11437",
    "data-name": "Path 11437",
    d: "M193.418,261.431a.423.423,0,1,0,.212.79.424.424,0,0,0,.155-.578A.425.425,0,0,0,193.418,261.431Z",
    transform: "translate(-182.78 -207.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11438",
    "data-name": "Path 11438",
    d: "M224.93,279.625a.423.423,0,1,0,.423.423A.424.424,0,0,0,224.93,279.625Z",
    transform: "translate(-212.624 -224.977)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11439",
    "data-name": "Path 11439",
    d: "M256.652,261.487a.423.423,0,1,0,.155.579A.423.423,0,0,0,256.652,261.487Z",
    transform: "translate(-242.467 -207.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11440",
    "data-name": "Path 11440",
    d: "M256.441,225.042a.423.423,0,1,0,.367.212A.424.424,0,0,0,256.441,225.042Z",
    transform: "translate(-242.467 -173.283)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.f3a735dc14b588b364fa5bcf97ff2b49.svg";
export { ForwardRef as ReactComponent };